export default (value: string) =>
  value
    .toLowerCase()
    .normalize('NFD') // Canonical Decomposition.
    .replace(/[\u0300-\u036f]/g, '') // Unwanted unicode characters
    .replace(/[\u0027\u2018\u2019]/g, '') // Apostrophe-like quotes
    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
    .replace(/--+/g, '-') // Replaces multiple hyphens by one hyphen
    .replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string